import { render } from "./KapibaraNavigation.vue?vue&type=template&id=4233a564"
import script from "./KapibaraNavigation.vue?vue&type=script&lang=js"
export * from "./KapibaraNavigation.vue?vue&type=script&lang=js"

import "./KapibaraNavigation.vue?vue&type=style&index=0&id=4233a564&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__